module.exports = __webpack_public_path__ + "img/COOPTHUMBNAIL.b1a4bdff.png";